import { BEGIN_OPTIMISTIC_UPDATE, COMMIT_OPTIMISTIC_UPDATE, REVERT_OPTIMISTIC_UPDATE } from '../optimistic.update.reducer';

export const CREATE_BATCH_REQUEST = 'CREATE_BATCH_REQUEST';
export const CREATE_BATCH_SUCCESS = 'CREATE_BATCH_SUCCESS';
export const CREATE_BATCH_FAILURE = 'CREATE_BATCH_FAILURE';
export const ADD_SALES_ORDERS_TO_BATCH_REQUEST = 'ADD_SALES_ORDERS_TO_BATCH_REQUEST';
export const ADD_SALES_ORDERS_TO_BATCH_SUCCESS = 'ADD_SALES_ORDERS_TO_BATCH_SUCCESS';
export const CREATE_BATCH_WITH_SALES_ORDERS_REQUEST = 'CREATE_BATCH_WITH_SALES_ORDERS_REQUEST';
export const CREATE_BATCH_WITH_SALES_ORDERS_SUCCESS = 'CREATE_BATCH_WITH_SALES_ORDERS_SUCCESS';
export const ADDED_SALES_ORDERS_TO_CREATED_BATCH_SUCCESS = 'ADDED_SALES_ORDERS_TO_CREATED_BATCH_SUCCESS';
export const SAVE_BATCHES_REQUEST = 'SAVE_BATCHES_REQUEST';
export const CANCEL_BATCH_REQUEST = 'CANCEL_BATCH_REQUEST';
export const CLEAR_BATCH = 'CLEAR_BATCH';
export const SAVE_BATCH_NAME_CHANGE_REQUEST = 'SAVE_BATCH_NAME_CHANGE_REQUEST';
export const SAVE_BATCH_NAME_CHANGE_SUCCESS = 'SAVE_BATCH_NAME_CHANGE_SUCCESS';
export const SAVE_BATCH_NAME_CHANGE_FAILURE = 'SAVE_BATCH_NAME_CHANGE_FAILURE';
export const CREATE_BATCH_WITH_FULFILLMENT_PLANS_REQUEST = 'CREATE_BATCH_WITH_FULFILLMENT_PLANS_REQUEST';
export const CREATE_BATCH_WITH_FULFILLMENT_PLANS_SUCCESS = 'CREATE_BATCH_WITH_FULFILLMENT_PLANS_SUCCESS';
export const CREATE_BATCH_WITH_FULFILLMENT_PLANS_FAILURE = 'CREATE_BATCH_WITH_FULFILLMENT_PLANS_FAILURE';
export const ADD_FULFILLMENT_PLANS_TO_BATCH_REQUEST = 'ADD_FULFILLMENT_PLANS_TO_BATCH_REQUEST';
export const ADD_FULFILLMENT_PLANS_OR_SALES_ORDERS_TO_BATCH_REQUEST = 'ADD_FULFILLMENT_PLANS_OR_SALES_ORDERS_TO_BATCH_REQUEST';
export const ADD_FULFILLMENT_PLANS_TO_BATCH_SUCCESS = 'ADD_FULFILLMENT_PLANS_TO_BATCH_SUCCESS';
export const ADDED_FULFILLMENT_PLANS_TO_CREATED_BATCH_SUCCESS = 'ADDED_FULFILLMENT_PLANS_TO_CREATED_BATCH_SUCCESS';
export const FULFILLMENT_PLANS_BLOCKED_FROM_BATCH = 'FULFILLMENT_PLANS_BLOCKED_FROM_BATCH';
export const SALES_ORDER_FULFILLMENT_PLANS_BLOCKED_FROM_BATCH = 'SALES_ORDER_FULFILLMENT_PLANS_BLOCKED_FROM_BATCH';
export const CANCEL_BLOCKED_ADD_TO_BATCH = 'CANCEL_BLOCKED_ADD_TO_BATCH';

export const createBatch = (name, note, assignToUserId) => ({
  type: CREATE_BATCH_REQUEST,
  name,
  note,
  assignToUserId,
});

export const createBatchSuccess = (fulfillmentPlanSetId) => ({
  type: CREATE_BATCH_SUCCESS,
  fulfillmentPlanSetId,
});

export const createBatchFailure = (error) => ({
  type: CREATE_BATCH_FAILURE,
  error,
});

export const addSalesOrdersToBatchSuccess = () => ({
  type: ADD_SALES_ORDERS_TO_BATCH_SUCCESS,
});

export const addFulfillmentPlansOrSalesOrderToBatchRequest = (fulfillmentPlanSetId, fulfillmentPlanIds = [], filters) => ({
  type: ADD_FULFILLMENT_PLANS_OR_SALES_ORDERS_TO_BATCH_REQUEST,
  fulfillmentPlanSetId,
  fulfillmentPlanIds,
  filters,
});

export const addedFulfillmentPlansToBatchSuccess = () => ({
  type: ADD_FULFILLMENT_PLANS_TO_BATCH_SUCCESS,
});

export const createBatchWithSalesOrders = (name, assignToUserId, salesOrderIds, filters) => ({
  type: CREATE_BATCH_WITH_SALES_ORDERS_REQUEST,
  name,
  assignToUserId,
  salesOrderIds,
  filters,
});

export const createBatchWithSalesOrdersSuccess = (fulfillmentPlanSetId, salesOrderIds, filters) => ({
  type: CREATE_BATCH_WITH_SALES_ORDERS_SUCCESS,
  fulfillmentPlanSetId,
  salesOrderIds,
  filters,
});

export const addedSalesOrdersToCreatedBatchSuccess = () => ({
  type: ADDED_SALES_ORDERS_TO_CREATED_BATCH_SUCCESS,
});

export const saveBatches = (batches) => ({
  type: SAVE_BATCHES_REQUEST,
  batches,
});

export const saveBatchNameChangeRequest = (batch) => ({
  type: SAVE_BATCH_NAME_CHANGE_REQUEST,
  batch,
});

export const saveBatchNameChangeSuccess = (batch) => ({
  type: SAVE_BATCH_NAME_CHANGE_SUCCESS,
  batch,
});

export const saveBatchNameChangeFailure = (error) => ({
  type: SAVE_BATCH_NAME_CHANGE_FAILURE,
  error,
});

export const cancelBatchRequest = (batchIds, isDetails) => ({
  type: CANCEL_BATCH_REQUEST,
  batchIds,
  isDetails,
});

export const clearBatch = (batchIds) => ({
  type: CLEAR_BATCH,
  batchIds,
});

export const createBatchWithFulfillmentPlans = (name, assignToUserId, fulfillmentPlanIds, shouldForceMoveFulfillmentPlans, filters) => ({
  type: CREATE_BATCH_WITH_FULFILLMENT_PLANS_REQUEST,
  name,
  assignToUserId,
  fulfillmentPlanIds,
  shouldForceMoveFulfillmentPlans,
  filters,
});

export const createBatchWithFulfillmentPlansSuccess = (
  fulfillmentPlanSetId,
  fulfillmentPlanIds,
  shouldForceMoveFulfillmentPlans,
  filters,
) => ({
  type: CREATE_BATCH_WITH_FULFILLMENT_PLANS_SUCCESS,
  fulfillmentPlanSetId,
  fulfillmentPlanIds,
  shouldForceMoveFulfillmentPlans,
  filters,
});

export const createBatchWithFulfillmentPlansFailure = (error) => ({
  type: CREATE_BATCH_WITH_FULFILLMENT_PLANS_FAILURE,
  error,
});

export const addedFulfillmentPlansToCreatedBatchSuccess = (fulfillmentPlanSetId) => ({
  type: ADDED_FULFILLMENT_PLANS_TO_CREATED_BATCH_SUCCESS,
  fulfillmentPlanSetId,
  meta: {
    optimistic: COMMIT_OPTIMISTIC_UPDATE,
  },
});

const ADDED_FULFILLMENT_PLANS_TO_CREATED_BATCH_FAILURE = 'ADDED_FULFILLMENT_PLANS_TO_CREATED_BATCH_FAILURE,';
export const addedFulfillmentPlansToCreatedBatchFailure = (err) => ({
  type: ADDED_FULFILLMENT_PLANS_TO_CREATED_BATCH_FAILURE,
  error: true,
  payload: new Error(err),
  meta: {
    optimistic: REVERT_OPTIMISTIC_UPDATE,
  },
});

export const fulfillmentPlansBlockedFromBatch = (
  fulfillmentPlansInOtherBatches,
  destinationFulfillmentPlanSetId,
  errorMessage,
  successMessage,
) => ({
  type: FULFILLMENT_PLANS_BLOCKED_FROM_BATCH,
  fulfillmentPlansInOtherBatches,
  destinationFulfillmentPlanSetId,
  errorMessage,
  successMessage,
});

export const salesOrderFulfillmentPlansBlockedFromBatch = (fulfillmentPlansInOtherBatches, destinationFulfillmentPlanSetId) => ({
  type: SALES_ORDER_FULFILLMENT_PLANS_BLOCKED_FROM_BATCH,
  fulfillmentPlansInOtherBatches,
  destinationFulfillmentPlanSetId,
});

export const FORCE_ADD_TO_BATCH = 'FORCE_ADD_TO_BATCH';
export const forceAddToBatch = (fulfillmentPlanSetId, fulfillmentPlanIds, errorMessage, successMessage) => ({
  type: FORCE_ADD_TO_BATCH,
  fulfillmentPlanSetId,
  fulfillmentPlanIds,
  errorMessage,
  successMessage,
  meta: {
    optimistic: BEGIN_OPTIMISTIC_UPDATE,
    onSuccess: addedFulfillmentPlansToCreatedBatchSuccess,
    onError: addedFulfillmentPlansToCreatedBatchFailure,
  },
});

export const cancelBlockedAddToBatch = () => ({
  type: CANCEL_BLOCKED_ADD_TO_BATCH,
});
